/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import ImageViewerController from './image-viewer-controller';

/**
 * @import { IElement } from '../div'
 * @import ViewerLifeCycleFactory from '../viewer/life-cycle/viewer-life-cycle-factory'
 * @import { ViewerControllerFactory } from '../viewer/controller'
 */

/**
 * Továrna na ovladače pro zobrazování obrázkových souborů.
 * @implements {ViewerControllerFactory}
 */
export default class ImageViewerControllerFactory {
  /**
   * Vytvoří instanci.
   * @param {ViewerLifeCycleFactory} lifeCycleFactory
   */
  constructor(lifeCycleFactory) {
    this.lifeCycleFactory = lifeCycleFactory;
  }

  /** @type {ViewerControllerFactory['create']} */
  create(el, settings) {
    return new ImageViewerController(
      /** @type {IElement} */ (el),
      this.lifeCycleFactory
    );
  }
}
